<template>
  <div>
    <h3>Regras de Contrapartidas</h3>

    <List />
  </div>
</template>

<script>
import List from "./Contrapartidas/List.vue";
export default {
  components: {
    List,
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      return true;
    },
  },
};
</script>

<style>
</style>
